<template>
  <div class="pay">
    <header>
      <img src="../../assets/images/card-img/card-ecommend-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
      <p>
        充值
      </p>
    </header>
    <section>
      <!-- 余额 充值金额 -->
      <div class="pay-t">
        <div class="pay-title">
          <p class="p1">
            充值金额
          </p>
          <p class="p2">
            <span>余额</span>
            <span>110</span>
            <span>元</span>
          </p>
        </div>
        <div class="pay-num">
          <span>
            ￥
          </span>
          <input type="number" placeholder="请输入您要充值的金额">
        </div>
      </div>
      <div class="pay-num-fixation">
        <div class="btn1">
          <p>
            100元
          </p>
          <p>
            送5元
          </p>
        </div>
        <div class="btn2">
          <p>
            150元
          </p>
          <p>
            送5元
          </p>
        </div>
        <div class="btn3">
          <p>
            200元
          </p>
          <p>
            送5元
          </p>
        </div>
      </div>
      <div class="pay-btn">
        立即充值
      </div>
    </section>
    <footer>

    </footer>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
  .pay{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: .01rem #BFBFBF solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      .pay-t{
        width: 100%;
        height: 2.46rem;
        border-bottom: .2rem #F4F4F4 solid;
        .pay-title{
          width: 100%;
          display: flex;
          align-items: center;
          .p1{
            font-family: PingFang-SC-Bold;
            font-weight: Bold;
            color: #333333;
            font-size: 0.32rem;
            margin-left: .41rem;
            margin-top: .43rem;
            line-height: .32rem;
          }
          .p2{
            margin-left: 3.44rem;
            margin-top: .38rem;
            line-height: .48em;
            span{
              &:first-child{
                font-family: PingFang-SC-Bold;
                font-weight: Bold;
                color: #333333;
                font-size: 0.32rem;
                margin-right: .3rem;
              }
              &:nth-child(2){
                font-family: SFUIText-Medium;
                color: #EF8201;
                font-size: 0.48rem;
              }
              &:last-child{
                font-family: Adobe Heiti Std R;
                color: #333333;
                font-size: 0.3rem;
              }
            }
          }
        }
        .pay-num{
          width: 100%;
          span{
            display: inline-block;
            font-family: PingFang-SC-Bold;
            font-weight: bold;
            color: #333333;
            font-size: 0.68rem;
            line-height: .68rem;
            margin-left: .4rem;
            margin-top: .7rem;

          }
          input{
            margin-left: .25rem;
            border: none;
            outline: none;
            font-size: .32rem;
          }
        }
      }
      .pay-num-fixation{
        display: flex;
        div{
          width: 2.2rem;
          height: 1.36rem;
          border: .01rem #EF8201 solid;
          border-radius: .1rem;
          margin-top: .43rem;
          text-align: center;
          color: #EF8201;
          &:first-child{
            margin-left: .3rem;
          }
          &:nth-child(2){
            margin-left: .15rem;
          }
          &:last-child{
            margin-left: .15rem;
          }
          p{
            &:first-child{
              font-family: PingFang-SC-Bold;
              font-weight: Bold;
              font-size: 0.36rem;
              line-height: .36rem;
              margin-top: .35rem;
            }
            &:last-child{
              font-family: PingFang-SC-Regular;
              color: #EF8201;
              font-size: 0.24rem;
              line-height: .24rem;
              margin-top: .17rem;
            }
          }
        }
      }
      .pay-btn{
        width: 6.9rem;
        height: .88rem;
        margin: 0 auto;
        background: #EF8201;
        border-radius: 0.1rem;
        font-family: PingFang-SC-Bold;
        color: #FFFFFF;
        font-size: 0.36rem;
        margin-top: 1.22rem;
        text-align: center;
        line-height: .88rem;
      }
    }
  }
</style>